import axios from 'axios';

import { getBackendUrl } from './getHostUrl';
import { getLocalToken } from '../indexeddb/cookieIdb';

let api = null;

const apiConfig = {
	baseURL: getBackendUrl(),
	timeout: 60000,
	headers: {
		'Content-Type': 'application/json',
	},
};

const createApi = async () => {
	api = await axios.create(apiConfig);
	return api;
};

const createApiAuthenticated = async (token) => {
	apiConfig.headers.Authorization = token;
	api = await axios.create(apiConfig);
	return api;
};

const removeTokenFromApi = async () => {
	delete apiConfig.headers.Authorization;
	api = await axios.create(apiConfig);
	return api;
};

const getAPI = async () => {
	if (api) return api;
	// if we have a token we obviously use it
	const token = await getLocalToken();
	if (token) {
		return createApiAuthenticated(token);
	}
	return createApi();
};

export { createApiAuthenticated, removeTokenFromApi, getAPI };
